import { type ComponentProps } from 'react';

import { Box } from 'app/shopify/theme';

type ColumnProps = ComponentProps<typeof Box>;

export function Column(props: ColumnProps) {
  return <Box {...props} flexDirection="column" />;
}
